<script>
export default {
  name: 'DocumentDownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5098 10.19H17.6198C15.2498 10.19 13.3198 8.26 13.3198 5.89V3C13.3198 2.45 12.8698 2 12.3198 2H8.07977C4.99977 2 2.50977 4 2.50977 7.57V16.43C2.50977 20 4.99977 22 8.07977 22H15.9398C19.0198 22 21.5098 20 21.5098 16.43V11.19C21.5098 10.64 21.0598 10.19 20.5098 10.19ZM12.2898 15.78L10.2898 17.78C10.2198 17.85 10.1298 17.91 10.0398 17.94C9.94977 17.98 9.85977 18 9.75977 18C9.65977 18 9.56977 17.98 9.47977 17.94C9.39977 17.91 9.31977 17.85 9.25977 17.79C9.24977 17.78 9.23977 17.78 9.23977 17.77L7.23977 15.77C6.94977 15.48 6.94977 15 7.23977 14.71C7.52977 14.42 8.00977 14.42 8.29977 14.71L9.00977 15.44V11.25C9.00977 10.84 9.34977 10.5 9.75977 10.5C10.1698 10.5 10.5098 10.84 10.5098 11.25V15.44L11.2298 14.72C11.5198 14.43 11.9998 14.43 12.2898 14.72C12.5798 15.01 12.5798 15.49 12.2898 15.78Z"
      :fill="color"
    />
    <path
      d="M17.4399 8.80999C18.3899 8.81999 19.7099 8.81999 20.8399 8.81999C21.4099 8.81999 21.7099 8.14999 21.3099 7.74999C19.8699 6.29999 17.2899 3.68999 15.8099 2.20999C15.3999 1.79999 14.6899 2.07999 14.6899 2.64999V6.13999C14.6899 7.59999 15.9299 8.80999 17.4399 8.80999Z"
      :fill="color"
    />
  </svg>
</template>
